import { render } from "./KpiCategoriesDropdown.vue?vue&type=template&id=ecf89382"
import script from "./KpiCategoriesDropdown.vue?vue&type=script&lang=js"
export * from "./KpiCategoriesDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__